<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :md="10" :lg="4">
                    <el-input placeholder="id" size="small" v-model="params.anchor_id"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="7">
                    <el-input placeholder="主播名称" size="small" v-model="params.nickname"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="5">
                    <el-input placeholder="手机" size="small" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="7">
                    <el-input placeholder="直播流名称" size="small" v-model="params.stream_name"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :md="10" :lg="5">
                    <el-select size="small" v-model="params.status" clearable placeholder="请选择状态" @change="search">
                        <el-option v-for="item in statusOption" :key="item.value" :label="item.title" size="mini" :value="item.value"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="10" :lg="5">
                    <el-select size="small" v-model="params.distributor_name" filterable placeholder="请选择店铺" remote :remote-method="getDistributorList" @change="handleDistibutorChange">
                        <el-option
                                v-for="item in distributorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col ><el-input v-model="params.inca_id" placeholder=""></el-input></el-col>
                    </div>
                </el-col>
                <el-col :md="10" :lg="8">
                    <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="false">
                <el-col :span="24">
                    <el-button-group>
                        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addItems" >添加</el-button>
                    </el-button-group>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName" type="border-card" >
                <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
                    <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange"  v-loading="loading">
                        <el-table-column type="selection" align="center" label="全选"></el-table-column>
                        <el-table-column label="操作" width="110" fixed>
                            <template slot-scope="scope">
                                <el-button type="text" class="btn-gap">
                                    <router-link :to="{ path: matchInternalRoute('livelist'), query: {anchor_id: scope.row.anchor_id,anchor_name:scope.row.nickname}}" class="btn-gap">直播记录</router-link>
                                </el-button>
                                <el-popover
                                        placement="right"
                                        width="245"
                                        trigger="hover">
                                    <div class="operating-icons">
                                        <!--<el-button type="text" :to="{ path: matchInternalRoute('Livelist'), query: {distributor_id: scope.row.distributor_id}}" class="btn-gap">直播记录</el-button>-->
                                        <el-button type="text" @click="editItemsAction(scope.$index, scope.row, false)" class="btn-gap">编辑</el-button>
                                        <el-button type="text" @click="deleteItemsAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
                                        <el-button type="text" v-if="scope.row.status == 'online'" @click="updateItemStatus(scope.row,'offline')" class="btn-gap" >下线</el-button>
                                        <el-button type="text" v-if="scope.row.status == 'offline'" @click="updateItemStatus(scope.row,'online')" class="btn-gap" >上线</el-button>
                                        <el-button type="text" @click="handleGetPushUrl(scope.row)" class="btn-gap" v-if="false">生成推流地址</el-button>
                                        <!--<router-link :to="{ path: matchInternalRoute('livelist'), query: {anchor_id: scope.row.anchor_id,anchor_name:scope.row.nickname}}" class="btn-gap">直播记录</router-link>-->
                                        <el-button type="text" @click="handleCreatePreNotice(scope.row)" class="btn-gap" >直播预告</el-button>
                                        <el-button type="text" @click="handleUploadVideo(scope.row)" class="btn-gap" >视频上传</el-button>
                                    </div>
                                    <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="anchor_id" label="主播ID" width="90"></el-table-column>
                        <el-table-column prop="user_id" label="会员ID" width="90" ></el-table-column>
                        <el-table-column prop="inca_id" label="店铺名称" width="90" show-overflow-tooltip >
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.distributor.name}}</template>
                        </el-table-column>
                        <el-table-column prop="name" label="员工姓名" width="90">
                            <template slot-scope="scope">{{scope.row.name}}</template>
                        </el-table-column>
                        <el-table-column prop="nickname" label="员工昵称" width="90">
                            <template slot-scope="scope">{{scope.row.nickname}}</template>
                        </el-table-column>
                        <el-table-column prop="mobile" label="手机号" width="120">
                            <template slot-scope="scope">{{scope.row.mobile}}</template>
                        </el-table-column>
                        <el-table-column prop="is_auth" align="center" label="是否授权" width="90" >
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.is_auth"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_record" align="center" label="是否录播" width="90" >
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.is_record"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchRecord(scope.$index, scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="disabled" label="是否禁用" width="90">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.disabled=='0'">可用</el-tag>
                                <el-tag size="mini" effect="plain" v-else>禁用</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="主播状态" width="90">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.status == 'online'">在线</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else>离线</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stream_name" label="直播流名称" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">{{scope.row.stream_name}}</template>
                        </el-table-column>
                        <el-table-column prop="updated_at" label="更新时间" width="160" align="center">
                            <template slot-scope="scope">{{scope.row.updated_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
                        </el-table-column>
                        <el-table-column prop="created_at" label="创建时间" width="160" align="center">
                            <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
                        </el-table-column>
                    </el-table>
                    <div class="content-center content-top-padded">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getDistributorList } from '../../../api/marketing'
    import {
        getAnchorList,
        updateAnchorStatus,
        deleteAnchor,
        updateRecordStatus,
        updateAuthStatus,
        getPushUrl,
    } from '../../../api/live'

    export default {
        data () {
            return {
                status:'',
                loading:true,
                tabList: [
                    {name: "列表", value: null, activeName: 'first'},
                    // {name: "库存预警商品", value: 'true', activeName: 'second'},
                ],
                activeName: 'first',
                ItemsList: [],
                params: {
                    page: 1,
                    pageSize: 20,
                    item_id:'',
                    anchor_id:'',
                    nickname:'',
                    mobile:'',
                    stream_name:'',
                    start_time:'',
                    end_time:'',
                    distributor_name:'',
                },
                total_count:0,
                statusOption: [
                    { title: '在线', value: 'online' },
                    { title: '离线', value: 'offline' },
                ],
                create_time:'',
                distributorList:[],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            handleSelectionChange (val) {
                let item_id = []
                for (let i in val) {
                    item_id.push(val[i].anchor_id)
                }
                this.item_id = item_id
            },
            dateChange (val) {
                if (val.length > 0) {
                    this.params.start_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_time = ''
                    this.params.end_time = ''
                }
                this.search();
            },
            handleGetPushUrl(row){
                let params = {
                    'id': row.anchor_id,
                }
                getPushUrl(params).then(res => {
                    if (res.data) {
                        const h = this.$createElement;
                        this.$message({
                            message: h('p', null, [
                                h('span', null, '生成推流地址： '),
                                h('p', { style: 'color: blue;padding-right:25px;' }, res.data.data.push_url)
                            ]),
                            showClose: true,
                            duration: 10 * 1000,
                        });
                    }
                })
            },
            switchRecord(index, row) {
                let params = {
                    'id': row.anchor_id,
                    'is_record': row.is_record ,
                }
                updateRecordStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        //this.getList()
                    }
                })
            },
            switchAuth(index, row) {
                let params = {
                    'id': row.anchor_id,
                    'is_auth': row.is_auth ,
                }
                updateAuthStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        //this.getList()
                    }
                })
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            addItems () { // 添加
                this.$router.push({path: this.matchHidePage('editor')})
            },
            editItemsAction (index, row, isNew) { // 编辑弹框
                if (isNew) {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.anchor_id, query: { is_new: true}});
                } else {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.anchor_id});
                }
            },
            handleCreatePreNotice(row){
                // this.$router.push({path: this.matchHidePage('child/') + row.anchor_id})
                this.$router.push({path: this.matchHidePage('editor_prenotice/') + row.anchor_id})
            },
            // 视频上传
            handleUploadVideo(row){
                this.$router.push({path: this.matchHidePage('editor_uploadvideo/') + row.anchor_id})
            },
            search () {
                this.params.page = 1
                this.getList()
            },
            getList () {
                this.loading = true
                getAnchorList(this.params).then(response => {
                    this.ItemsList = response.data.data.list
                    this.ItemsList.forEach(item => {
                        item.price = item.price/100
                        item.link = `pages/item/espier-detail?gid=${item.goods_id}&id=${item.item_id}`
                    })
                    this.total_count = response.data.data.total_count
                    this.warning_store = response.data.data.warning_store
                    this.loading = false
                })
            },
            deleteItemsAction (index, row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteAnchor(row.anchor_id).then(response => {W
                        this.ItemsList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            updateItemStatus (items,status) {
                this.loading = true
                let params = {}
                params = {
                    'id': items.anchor_id,
                    'status': status,
                }
                updateAnchorStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getList()
                    }
                })
                this.loading = false
            },
            getDistributorList(val){
                getDistributorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.distributorList = [{name:'请选择店铺',id:null}];
                    for (let item of res.data.data.list) {
                        this.distributorList.push({name: item.name, id: item.number})
                    }
                })
            },
            handleDistibutorChange:function (val){
                this.params.inca_id = val
                this.getList()
            },
        },
        mounted () {
            this.params = this.$route.query
            this.getList()
            this.getDistributorList()
        },
        watch: {
            getStatus (val) {
                if (val) {
                    this.getList()
                }
            },
            $route(){
                this.getList()
            }
        }
    }

</script>



// WEBPACK FOOTER //
// list.vue?72b9d467